export default {
  data() {
    return {
      form: {},
      validation: {},
    };
  },
  methods: {
    initForm() {
      this.form = {
        current_password: '',
        password: '',
        password_confirmation: '',
      };
    },
    initValidation() {
      this.validation = {
        current_password: {
          valid: null,
          message: '',
        },
        password: {
          valid: null,
          message: '',
        },
        password_confirmation: {
          valid: null,
          message: '',
        },
      };
    },
    onSubmit() {
      this.initValidation();
      this.changePassword(this.form);
    },
  },
  created() {
    this.initForm();
    this.initValidation();
  },
};
